import React, { useEffect, useRef, useState } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { PiMicrophoneFill } from "react-icons/pi";
import { toast } from "react-toastify";
import { useNewton } from "../../store/NewtonContext";

export default function VoiceMic({ lang = "en-US" }) {
  const { setMessage, setMessageHtml } = useNewton();

  const [manualListening, setManualListening] = useState(false);

  const {
    browserSupportsSpeechRecognition,
    listening,
    resetTranscript,
    transcript,
  } = useSpeechRecognition();

  // Stream interim text while speaking (optional, feels “live”)
  useEffect(() => {
    if (!transcript) return;
    setMessage(transcript);
    setMessageHtml(transcript);
  }, [transcript, setMessage, setMessageHtml]);

  const toggle = async () => {
    try {
      if (!manualListening) {
        resetTranscript();
        await SpeechRecognition.startListening({
          continuous: true,
          interimResults: true,
          language: lang,
        });
        setManualListening(true);
      } else {
        await SpeechRecognition.stopListening();
        setManualListening(false);
      }
    } catch (e) {
      toast.error("Mic error");
      console.error(e);
    }
  };

  useEffect(() => {
    return () => {
      if (!listening) return;
      SpeechRecognition.stopListening().catch((error) => {
        console.error("Failed to stop mic on unmount", error);
      });
      setManualListening(false);
    };
  }, [listening]);

  return (
    <>
      {browserSupportsSpeechRecognition ? (
        <PiMicrophoneFill
          aria-label="Voice input"
          className={[
            "size-6 cursor-pointer transition-colors",
            listening ? "text-primary200 animate-pulse" : "text-white",
          ].join(" ")}
          onClick={toggle}
          title={listening ? "Listening… click to stop" : "Click to speak"}
        />
      ) : (
        <></>
      )}
    </>
  );
}
